import UserMenu from "../../views/account/UserMenu";
import UserEdit from "../../views/account/UserEdit";
import UserAddresses from "../../views/account/Addresses";
import UserRegistration from "../../views/account/Registration";
import UserLogin from "../../views/account/Login";
import UserPswRemember from "../../views/account/password/Remember";
import UserPswReset from "../../views/account/password/Reset";
import UserPayments from "../../views/account/Payments";

export default [
    {
        path: '/utente',
        name: 'user',
        component: UserMenu,
        meta: {requiresAuth: true, showNav: true}
    },
    {
        path: '/utente/modifica',
        name: 'user.edit',
        component: UserEdit,
        meta: {requiresAuth: true, showNav: true}
    },
    {
        path: '/utente/indirizzi',
        name: 'user.addresses',
        component: UserAddresses,
        meta: {requiresAuth: true, showNav: true, requiresDeliveryActive: true}
    },
    {
        path: '/utente/metodi-pagamento',
        name: 'user.payments',
        component: UserPayments,
        meta: {requiresAuth: true, showNav: true, requiresStripe: true}
    },
    {
        path: '/utente/registrazione',
        name: 'user.registration',
        component: UserRegistration,
        meta: {showNav: true}
    },
    {
        path: '/utente/login',
        name: 'user.login',
        component: UserLogin,
        meta: {showNav: true}
    },
    {
        path: '/utente/password/remember',
        name: 'user.password.remember',
        component: UserPswRemember,
        meta: {showNav: true}
    },
    {
        path: '/utente/password/reset/:token',
        name: 'user.password.reset',
        component: UserPswReset,
        meta: {showNav: true}
    }
]
